import { supabase } from "./supabase";
import { API, getAuthToken } from "./api";
import axios from "axios";
import { instagramHref } from "./instagram";

async function adminAuthHeader() {
  const { data, error } = await supabase.auth.getSession();
  if (!error && data.session?.access_token) {
    return { Authorization: `Bearer ${data.session.access_token}` };
  }
  const appToken = getAuthToken();
  if (appToken) {
    return { Authorization: `Bearer ${appToken}` };
  }
  throw new Error("Sign in required.");
}

async function adminRequest(method, path, body) {
  const headers = await adminAuthHeader();
  const config = { headers };
  const url = `${API}/admin${path}`;
  if (method === "get") return (await axios.get(url, config)).data;
  if (method === "patch") return (await axios.patch(url, body, config)).data;
  if (method === "post") return (await axios.post(url, body, config)).data;
  throw new Error(`Unsupported admin method: ${method}`);
}

export async function adminGet(path) {
  return adminRequest("get", path);
}

export async function adminPatch(path, body) {
  return adminRequest("patch", path, body);
}

export async function adminPost(path, body) {
  return adminRequest("post", path, body);
}

export function organizerInstagramUrl(org) {
  return instagramHref(org?.personal_instagram || org?.school_instagram || "");
}
